// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itinerary-form .input-wrapper {
  min-height: 75px;
  width: 100%;
}
.itinerary-form .input-wrapper .select-label {
  height: fit-content;
}
.itinerary-form .itneries-select {
  border: none !important;
  border-radius: 0 !important;
  border-bottom: 1px solid var(--hover-color) !important;
  position: relative;
  top: 22%;
  color: #b4b3b3 !important;
  font-size: 16px !important;
  text-transform: capitalize;
}
.itinerary-form select.itneries-select.form-select:focus {
  outline: none; /* Remove default focus outline */
  border-bottom: 1px solid var(--hover-color) !important; /* Maintain custom border-bottom */
}
.itinerary-form .itneries-select option {
  background-color: transparent;
  border: none !important;
  color: black;
}
.itinerary-form .calenderIcon {
  position: absolute;
  right: 5px;
}
.itinerary-form select.itneries-select.valueSelect.form-select {
  color: var(--primary-font-color) !important;
}
.itinerary-form .exchange-destination-icon {
  top: 45px;
  cursor: pointer;
  padding: 4px;
  position: relative;
  right: 10px;
}
.itinerary-form .itneries-button-check-availibity-button {
  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%) !important;
  border: 0;
  border: none !important;
  font-size: 16px;
}
.itinerary-form .itneries-links {
  display: flex;
  gap: 15px;
  margin-left: 20px;
  align-items: center;
}
.itinerary-form .selected-tabs {
  background-color: #ffffff !important;
  border: 1px solid rgba(197, 197, 197, 0.5019607843) !important;
  margin-left: 10px;
  color: #BBBBBB !important;
  border-radius: 8px;
  cursor: pointer;
}
.itinerary-form .selected-tabs-active {
  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);
  border: none !important;
  margin-left: 10px;
  color: #ffffff !important;
  border-radius: 8px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/AddLeads/stepTwo/Components/IntineraryForm.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,WAAA;AAAJ;AACI;EACE,mBAAA;AACN;AAEE;EACE,uBAAA;EACA,2BAAA;EACA,sDAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;AAAJ;AAEE;EACE,aAAA,EAAA,iCAAA;EACA,sDAAA,EAAA,kCAAA;AAAJ;AAEE;EACE,6BAAA;EACA,uBAAA;EACA,YAAA;AAAJ;AAGE;EACE,kBAAA;EACA,UAAA;AADJ;AAGA;EAEE,2CAAA;AAFF;AAIA;EACE,SAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAFF;AAMA;EACI,oFAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AAJJ;AAOE;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;AALJ;AAQE;EACE,oCAAA;EACA,8DAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AANJ;AAQE;EACE,yEAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AANJ","sourcesContent":[".itinerary-form{\n  .input-wrapper{\n    min-height: 75px;\n    width: 100%;\n    .select-label{\n      height: fit-content;\n    }\n  }\n  .itneries-select {\n    border: none !important;\n    border-radius: 0 !important;\n    border-bottom: 1px solid var(--hover-color) !important;\n    position: relative;\n    top: 22%;\n    color: #b4b3b3 !important;\n    font-size: 16px !important;\n    text-transform: capitalize;\n  }\n  select.itneries-select.form-select:focus {\n    outline: none; /* Remove default focus outline */\n    border-bottom: 1px solid var(--hover-color) !important; /* Maintain custom border-bottom */\n  }\n  .itneries-select option {\n    background-color: transparent; \n    border: none !important; \n    color: black; \n  }\n  \n  .calenderIcon {\n    position: absolute;\n    right: 5px;\n}\nselect.itneries-select.valueSelect.form-select {\n\n  color: var(--primary-font-color) !important;\n}\n.exchange-destination-icon{\n  top: 45px;\n  cursor: pointer;\n  padding: 4px;\n  position: relative;\n  right:10px;\n\n}\n\n.itneries-button-check-availibity-button{\n    background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%) !important;\n    border: 0;\n    border: none !important;\n    font-size: 16px;\n  }\n\n  .itneries-links{\n    display: flex;\n    gap: 15px;\n    margin-left: 20px;\n    align-items: center;\n  }\n\n  .selected-tabs{\n    background-color: #ffffff !important;\n    border: 1px solid #C5C5C580 !important;\n    margin-left: 10px;\n    color: #BBBBBB !important;\n    border-radius: 8px;\n    cursor: pointer;\n  }\n  .selected-tabs-active{\n    background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);\n    border: none !important;\n    margin-left: 10px;\n    color: #ffffff !important;\n    border-radius: 8px;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
